<div class="d-flex flex-column h-100">
  <ziro-top-nav></ziro-top-nav>
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="row h-100 m-0" [hidden]="isLoading">
    <ziro-user-detail-card class="col-lg-2 col-md-3 p-0"></ziro-user-detail-card>
    <div class="col-lg-10 col-md-9 user-detail-pane">
      <div class="user-detail-pane__outlet">
        @if (!hideBreadcrumb) {
          <ziro-breadcrumbs></ziro-breadcrumbs>
        }
        <div>
          <router-outlet></router-outlet>
        </div>
      </div>
      <ziro-bottom-nav class="user-detail-pane__bottom-nav"></ziro-bottom-nav>
    </div>
  </div>
</div>
